export const documentsList = [
  { prop: 'isPeriod', title: 'Отчет по Хартии', func: 'openModal' },
  {
    prop: 'dialogVisible',
    title: 'Формирование платежек',
    func: 'openModal',
    action: 'doPayDoc',
  },
  {
    prop: 'overAktsVis',
    title: 'Формирование перевыставленных актов',
    func: 'openModal',
    action: 'doOverAkts',
  },
  {
    prop: 'doImportPayBank',
    title: 'Импорт платежей из банка',
    func: 'openModal',
    action: 'doImportPayBank',
  },
  {
    prop: 'saveNomModal',
    title: 'Документы по заказчику и дате',
    func: 'openModal',
    action: 'saveNomenclature',
  },
  {
    prop: 'UnknownFiles',
    title: 'Работа с файлами из терминалов',
    func: 'goTo',
    action: 'unknownFiles',
  },
  {
    title: 'Сегодняшние погрузки',
    func: 'todayResponses',
  },
  {
    title: 'Завтрашние погрузки',
    func: 'tomorrowResponses',
  },
  {
    prop: 'isSzvnOpen',
    title: 'Выгрузка погрузок по заказчикам, которые требуют СЗВМ',
    func: 'openModal',
  },
  {
    title: 'Авто без ТТН',
    func: 'withoutTtn',
  },
  {
    title: 'Сдизы и КС',
    func: 'showSDIZes',
  },
]

export const banksList = [
  {
    label: 'Сбербанк',
    value: 'sber',
  },
  {
    label: 'Точкабанк',
    value: 'point',
  },
]
